import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const biFormsBySiteAndDateRequest = createRequest(constants.biFormsBySiteAndDate);
export const biFormsBySiteAndDateSuccess = createSuccess(constants.biFormsBySiteAndDate);
export const biFormsBySiteAndDateFailure = createFailure(constants.biFormsBySiteAndDate);

export const biFormsByDateRequest = createRequest(constants.biFormsByDate);
export const biFormsByDateSuccess = createSuccess(constants.biFormsByDate);
export const biFormsByDateFailure = createFailure(constants.biFormsByDate);

export const biFormsByCategoryRequest = createRequest(constants.biFormsByCategory);
export const biFormsByCategorySuccess = createSuccess(constants.biFormsByCategory);
export const biFormsByCategoryFailure = createFailure(constants.biFormsByCategory);

export const setLoadingState = createAction(constants.setLoadingState);

export const requestBIFormsBySiteAndDate = biFormsBySiteAndDateRequest;
export const requestBIFormsByDate = biFormsByDateRequest;
export const requestBIFormsByCategory = biFormsByCategoryRequest;
